<template>
  <AiEducationLayout>
  <ContentWrap>
    <el-tabs v-model="tab" @tab-change="load">
      <el-tab-pane label="内容审核" name="content">
        <div class="mb-12px flex gap-8px">
          <el-select
            v-model="courseId"
            clearable
            filterable
            placeholder="选择课程"
            style="width: 220px"
          >
            <el-option
              v-for="item in courses"
              :key="item.id"
              :label="item.title || item.name"
              :value="item.id"
            />
          </el-select>
          <el-select v-model="contentStatus" clearable placeholder="全部状态" style="width: 140px">
            <el-option label="草稿" :value="0" /><el-option label="待审核" :value="10" />
            <el-option label="已批准" :value="20" /><el-option
              label="已发布"
              :value="30"
            /><el-option label="已退回" :value="40" />
          </el-select>
          <el-button :icon="Search" @click="load">查询</el-button>
        </div>
        <el-table v-loading="loading" :data="drafts">
          <el-table-column prop="title" label="标题" min-width="200" /><el-table-column
            label="课程"
            min-width="160"
            ><template #default="s">{{
              courseName(s.row.trainCourseId)
            }}</template></el-table-column
          >
          <el-table-column label="类型" width="100"
            ><template #default="s">{{
              contentTypeName(s.row.contentType)
            }}</template></el-table-column
          ><el-table-column prop="version" label="版本" width="80" />
          <el-table-column label="状态" width="100"
            ><template #default="s"
              ><el-tag :type="contentStatusType(s.row.status)">{{
                contentStatusName(s.row.status)
              }}</el-tag></template
            ></el-table-column
          >
          <el-table-column label="操作" width="290"
            ><template #default="s">
              <el-button link type="primary" @click="openDraft(s.row)">查看</el-button>
              <el-button
                v-if="[0, 40].includes(s.row.status)"
                v-hasPermi="['ai-education:content:write']"
                link
                type="primary"
                @click="openDraft(s.row)"
                >编辑</el-button
              >
              <el-button
                v-if="s.row.status === 0"
                v-hasPermi="['ai-education:content:write']"
                link
                type="warning"
                @click="submitDraftReview(s.row.id)"
                >提交审核</el-button
              >
              <el-button v-if="s.row.evidenceJson" link type="primary" @click="showEvidence(s.row)"
                >查看依据</el-button
              >
              <el-button
                v-if="s.row.status === 10"
                link
                type="success"
                @click="review(s.row.id, true)"
                >批准</el-button
              >
              <el-button
                v-if="s.row.status === 10"
                link
                type="danger"
                @click="review(s.row.id, false)"
                >退回</el-button
              >
              <el-button v-if="s.row.status === 20" link type="primary" @click="publish(s.row.id)"
                >发布</el-button
              >
            </template></el-table-column
          >
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="AI 备课" name="lesson">
        <el-form :model="lessonForm" label-width="100px" class="max-w-600px">
          <el-form-item label="学校">
            <el-select
              v-model="lessonForm.schoolId"
              class="w-100%"
              filterable
              placeholder="请选择学校"
            >
              <el-option
                v-for="item in schools"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="课程">
            <el-select
              v-model="lessonForm.trainCourseId"
              class="w-100%"
              filterable
              placeholder="请选择课程"
            >
              <el-option
                v-for="item in courses"
                :key="item.id"
                :label="item.title || item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="生成类型"
            ><el-select v-model="lessonForm.contentType"
              ><el-option label="课程大纲" :value="1" /><el-option
                label="知识卡片"
                :value="2" /><el-option label="练习题" :value="3" /><el-option
                label="作业草稿"
                :value="4" /></el-select
          ></el-form-item>
          <el-form-item label="主题"
            ><el-input v-model="lessonForm.topic" type="textarea" :rows="4"
          /></el-form-item>
          <el-form-item label="语言"
            ><el-select v-model="lessonForm.language"
              ><el-option label="中文" value="zh-CN" /><el-option
                label="English"
                value="en-US" /></el-select
          ></el-form-item>
          <el-form-item
            ><el-button type="primary" :loading="lessonGenerating" @click="generateLesson"
              >生成待审核草稿</el-button
            ></el-form-item
          >
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="资源处理" name="resource">
        <div class="mb-12px flex gap-8px"
          ><el-select
            v-model="courseId"
            clearable
            filterable
            placeholder="选择课程"
            style="width: 220px"
            ><el-option
              v-for="item in courses"
              :key="item.id"
              :label="item.title || item.name"
              :value="item.id" /></el-select
          ><el-button :icon="Search" @click="load">查询</el-button
          ><el-button
            v-hasPermi="['ai-education:resource:write']"
            type="primary"
            @click="resourceDialog = true"
            >新增资源</el-button
          ></div
        >
        <el-table v-loading="loading" :data="resources"
          ><el-table-column prop="fileName" label="文件" min-width="180" /><el-table-column
            label="课程"
            min-width="160"
            ><template #default="s">{{
              courseName(s.row.trainCourseId)
            }}</template></el-table-column
          ><el-table-column label="知识库" min-width="150"
            ><template #default="s">{{
              knowledgeName(s.row.knowledgeId)
            }}</template></el-table-column
          ><el-table-column label="状态" width="100"
            ><template #default="s">{{
              ({ 0: '待处理', 10: '处理中', 30: '已摄取', 40: '失败' } as any)[s.row.status]
            }}</template></el-table-column
          ><el-table-column prop="aiDocumentId" label="AI 文档 ID" width="110" /><el-table-column
            prop="errorMessage"
            label="失败原因"
            min-width="220"
            show-overflow-tooltip
          /><el-table-column label="操作" width="90"
            ><template #default="s"
              ><el-button
                v-if="s.row.status === 40 && s.row.retryCount < 3"
                link
                type="primary"
                @click="retryResource(s.row.id)"
                >重试</el-button
              ></template
            ></el-table-column
          ></el-table
        >
      </el-tab-pane>
      <el-tab-pane label="设备管理" name="device">
        <div class="mb-12px flex gap-8px"
          ><el-select
            v-model="deviceSchoolId"
            clearable
            filterable
            placeholder="全部学校"
            style="width: 220px"
            @change="load"
            ><el-option
              v-for="item in schools"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select
          ><el-button
            v-hasPermi="['ai-education:device:write']"
            type="primary"
            @click="openDeviceDialog"
            >注册设备</el-button
          ></div
        >
        <el-table v-loading="loading" :data="devices">
          <el-table-column prop="deviceCode" label="设备编码" min-width="160" /><el-table-column
            prop="model"
            label="型号"
          />
          <el-table-column prop="appVersion" label="应用版本" /><el-table-column
            prop="lastHeartbeatTime"
            label="最近心跳"
            width="180"
          />
          <el-table-column prop="status" label="状态" width="80" />
          <el-table-column label="操作" width="200"
            ><template #default="s"
              ><el-button
                v-hasPermi="['ai-education:device:write']"
                link
                type="primary"
                @click="openBindingDialog(s.row)"
                >绑定用户</el-button
              ><el-button
                v-hasPermi="['ai-education:device:command']"
                link
                type="warning"
                @click="openCommandDialog(s.row)"
                >下发命令</el-button
              ><el-button
                v-hasPermi="['ai-education:device:query']"
                link
                @click="showCommands(s.row)"
                >记录</el-button
              ></template
            ></el-table-column
          >
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="试点问题" name="pilot">
        <div class="mb-12px flex gap-8px"
          ><el-select
            v-model="pilotSchoolId"
            clearable
            filterable
            placeholder="选择学校"
            style="width: 200px"
            @change="loadPilots"
            ><el-option
              v-for="item in schools"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select
          ><el-select
            v-model="pilotId"
            clearable
            filterable
            placeholder="选择试点项目"
            style="width: 220px"
            @change="load"
            ><el-option
              v-for="item in pilots"
              :key="item.id"
              :label="item.name || item.title"
              :value="item.id" /></el-select
          ><el-button :icon="Search" @click="load">查询</el-button
          ><el-button
            v-hasPermi="['ai-education:pilot:write']"
            type="primary"
            @click="openPilotProject"
            >新增试点</el-button
          ><el-button
            v-hasPermi="['ai-education:pilot:write']"
            :disabled="!pilotId"
            @click="openMetric"
            >登记指标</el-button
          ><el-button
            v-hasPermi="['ai-education:pilot:write']"
            :disabled="!pilotId"
            @click="openIssue"
            >登记问题</el-button
          ></div
        >
        <el-table v-if="metrics.length" :data="metrics" class="mb-16px" max-height="240"
          ><el-table-column prop="metricDate" label="日期" width="120" /><el-table-column
            prop="metricCode"
            label="指标"
            min-width="160" /><el-table-column
            prop="metricValue"
            label="数值"
            width="120" /><el-table-column prop="unit" label="单位" width="100" /><el-table-column
            prop="source"
            label="来源"
            width="100"
        /></el-table>
        <el-table v-loading="loading" :data="issues">
          <el-table-column prop="title" label="问题" min-width="200" /><el-table-column
            prop="severity"
            label="级别"
            width="80"
          />
          <el-table-column prop="description" label="说明" min-width="240" /><el-table-column
            prop="status"
            label="状态"
            width="80"
          />
          <el-table-column label="操作" width="100"
            ><template #default="s"
              ><el-button v-if="s.row.status !== 20" link type="primary" @click="resolve(s.row.id)"
                >解决</el-button
              ></template
            ></el-table-column
          >
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="AI 评测" name="evaluation">
        <div class="mb-12px flex gap-8px">
          <el-select
            v-model="evaluationSchoolId"
            clearable
            filterable
            placeholder="选择学校"
            style="width: 200px"
          >
            <el-option v-for="item in schools" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select
            v-model="courseId"
            clearable
            filterable
            placeholder="选择课程"
            style="width: 220px"
          >
            <el-option
              v-for="item in courses"
              :key="item.id"
              :label="item.title || item.name"
              :value="item.id"
            />
          </el-select>
          <el-button :icon="Search" @click="load">查询</el-button>
          <el-button
            v-hasPermi="['ai-education:evaluation:write']"
            type="primary"
            @click="openEvaluationCase()"
            >新增用例</el-button
          >
        </div>
        <el-table v-loading="loading" :data="evaluationCases">
          <el-table-column prop="name" label="用例" min-width="160" />
          <el-table-column label="学校" min-width="140"
            ><template #default="s">{{ schoolName(s.row.schoolId) }}</template></el-table-column
          >
          <el-table-column label="课程" min-width="160"
            ><template #default="s">{{
              courseName(s.row.trainCourseId)
            }}</template></el-table-column
          >
          <el-table-column prop="category" label="分类" width="120" />
          <el-table-column prop="question" label="问题" min-width="240" show-overflow-tooltip />
          <el-table-column label="操作" width="190"
            ><template #default="s">
              <el-button
                v-hasPermi="['ai-education:evaluation:write']"
                link
                type="primary"
                @click="openEvaluationCase(s.row)"
                >编辑</el-button
              >
              <el-button
                v-hasPermi="['ai-education:evaluation:run']"
                link
                type="success"
                @click="runEvaluation(s.row.id)"
                >执行</el-button
              >
              <el-button link type="primary" @click="showEvaluationResults(s.row.id)"
                >结果</el-button
              >
            </template></el-table-column
          >
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="内容版权" name="license">
        <div class="mb-12px flex gap-8px">
          <el-select
            v-model="courseId"
            clearable
            filterable
            placeholder="选择课程"
            style="width: 220px"
          >
            <el-option
              v-for="item in courses"
              :key="item.id"
              :label="item.title || item.name"
              :value="item.id"
            />
          </el-select>
          <el-button :icon="Search" @click="load">查询</el-button>
          <el-button
            v-hasPermi="['ai-education:content-license:write']"
            type="primary"
            @click="openContentLicense()"
            >登记版权</el-button
          >
        </div>
        <el-table v-loading="loading" :data="contentLicenses">
          <el-table-column label="课程" min-width="160"
            ><template #default="s">{{
              courseName(s.row.trainCourseId)
            }}</template></el-table-column
          >
          <el-table-column prop="copyrightOwner" label="版权方" min-width="160" />
          <el-table-column prop="licenseType" label="授权类型" width="120" />
          <el-table-column prop="licenseNo" label="授权编号" min-width="140" />
          <el-table-column prop="endTime" label="有效期至" min-width="170" />
          <el-table-column label="状态" width="100"
            ><template #default="s"
              ><el-tag :type="contentLicenseStatus(s.row).type">{{
                contentLicenseStatus(s.row).label
              }}</el-tag></template
            ></el-table-column
          >
          <el-table-column label="操作" width="130"
            ><template #default="s">
              <el-button
                v-hasPermi="['ai-education:content-license:write']"
                link
                type="primary"
                @click="openContentLicense(s.row)"
                >编辑</el-button
              >
              <el-button
                v-if="s.row.status === 20"
                v-hasPermi="['ai-education:content-license:write']"
                link
                type="danger"
                @click="disableContentLicense(s.row.id)"
                >停用</el-button
              >
            </template></el-table-column
          >
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </ContentWrap>
  <Dialog v-model="resourceDialog" title="新增课程资源" width="560px"
    ><el-form :model="resourceForm" label-width="100px"
      ><el-form-item label="学校"
        ><el-select
          v-model="resourceForm.schoolId"
          class="w-100%"
          filterable
          placeholder="请选择学校"
          ><el-option
            v-for="item in schools"
            :key="item.id"
            :label="item.name"
            :value="item.id" /></el-select></el-form-item
      ><el-form-item label="课程"
        ><el-select
          v-model="resourceForm.trainCourseId"
          class="w-100%"
          filterable
          placeholder="请选择课程"
          ><el-option
            v-for="item in courses"
            :key="item.id"
            :label="item.title || item.name"
            :value="item.id" /></el-select></el-form-item
      ><el-form-item label="知识库"
        ><el-select
          v-model="resourceForm.knowledgeId"
          class="w-100%"
          filterable
          placeholder="请选择知识库"
          ><el-option
            v-for="item in knowledgeBases"
            :key="item.id"
            :label="item.name"
            :value="item.id" /></el-select></el-form-item
      ><el-form-item label="文件名称"><el-input v-model="resourceForm.fileName" /></el-form-item
      ><el-form-item label="资源文件" required
        ><UploadFile
          v-model="resourceForm.fileUrl"
          :limit="1"
          replace-on-exceed
          :file-size="100"
          :file-type="['pdf', 'ppt', 'pptx', 'doc', 'docx', 'txt', 'md']"
          @upload-success="onResourceUploaded" /></el-form-item
      ><el-form-item label="文件类型"
        ><el-select v-model="resourceForm.fileType"
          ><el-option
            v-for="t in ['pdf', 'ppt', 'pptx', 'doc', 'docx', 'txt', 'md']"
            :key="t"
            :label="t"
            :value="t" /></el-select></el-form-item
      ><el-form-item label="分片 Token"
        ><el-input-number
          v-model="resourceForm.segmentMaxTokens"
          :min="100"
          :max="4000" /></el-form-item></el-form
    ><template #footer
      ><el-button @click="resourceDialog = false">取消</el-button
      ><el-button type="primary" :loading="resourceSubmitting" @click="submitResource"
        >提交处理</el-button
      ></template
    ></Dialog
  >
  <Dialog v-model="evidenceDialog" title="AI 备课生成依据" width="900px">
    <el-descriptions v-if="selectedDraft" :column="3" border class="mb-16px">
      <el-descriptions-item label="知识库">{{
        knowledgeName(selectedDraft.knowledgeId)
      }}</el-descriptions-item>
      <el-descriptions-item label="模型">{{
        modelName(selectedDraft.aiModelId)
      }}</el-descriptions-item>
      <el-descriptions-item label="提示词版本">{{
        selectedDraft.promptVersion
      }}</el-descriptions-item>
      <el-descriptions-item label="输入 Token">{{
        selectedDraft.inputTokens || 0
      }}</el-descriptions-item>
      <el-descriptions-item label="输出 Token">{{
        selectedDraft.outputTokens || 0
      }}</el-descriptions-item>
      <el-descriptions-item label="生成时间">{{
        selectedDraft.generatedTime
      }}</el-descriptions-item>
    </el-descriptions>
    <el-table :data="evidenceRows" max-height="500">
      <el-table-column prop="documentId" label="文档 ID" width="100" />
      <el-table-column prop="segmentId" label="切片 ID" width="100" />
      <el-table-column label="相似度" width="100"
        ><template #default="s">{{
          Number(s.row.similarity || 0).toFixed(4)
        }}</template></el-table-column
      >
      <el-table-column prop="content" label="引用内容" min-width="460" show-overflow-tooltip />
    </el-table>
  </Dialog>
  <Dialog
    v-model="draftDialog"
    :title="draftEditable ? '编辑内容草稿' : '查看内容草稿'"
    width="900px"
  >
    <el-form :model="draftForm" label-width="90px"
      ><el-form-item label="课程"
        ><el-input :model-value="courseName(draftForm.trainCourseId)" disabled /></el-form-item
      ><el-form-item label="类型"
        ><el-select v-model="draftForm.contentType" :disabled="!draftEditable"
          ><el-option label="课程大纲" :value="1" /><el-option
            label="知识卡片"
            :value="2" /><el-option label="练习题" :value="3" /><el-option
            label="作业草稿"
            :value="4" /></el-select></el-form-item
      ><el-form-item label="标题" required
        ><el-input v-model="draftForm.title" :disabled="!draftEditable" /></el-form-item
      ><el-form-item label="内容" required
        ><el-input
          v-model="draftForm.content"
          type="textarea"
          :rows="20"
          :disabled="!draftEditable" /></el-form-item
    ></el-form>
    <template #footer
      ><el-button @click="draftDialog = false">关闭</el-button
      ><el-button v-if="draftEditable" :loading="draftSaving" type="primary" @click="saveDraft"
        >保存草稿</el-button
      ></template
    >
  </Dialog>
  <Dialog v-model="deviceDialog" title="注册教育终端" width="560px"
    ><el-form :model="deviceForm" label-width="100px"
      ><el-form-item label="学校" required
        ><el-select v-model="deviceForm.schoolId" filterable class="w-100%"
          ><el-option
            v-for="item in schools"
            :key="item.id"
            :label="item.name"
            :value="item.id" /></el-select></el-form-item
      ><el-form-item label="设备编码" required
        ><el-input v-model="deviceForm.deviceCode" /></el-form-item
      ><el-form-item label="序列号"><el-input v-model="deviceForm.serialNumber" /></el-form-item
      ><el-form-item label="平台"
        ><el-select v-model="deviceForm.platform" class="w-100%"
          ><el-option label="Android" value="ANDROID" /><el-option
            label="Web/PWA"
            value="WEB" /></el-select></el-form-item
      ><el-form-item label="型号"><el-input v-model="deviceForm.model" /></el-form-item
      ><el-form-item label="系统版本"><el-input v-model="deviceForm.osVersion" /></el-form-item
      ><el-form-item label="应用版本"><el-input v-model="deviceForm.appVersion" /></el-form-item
      ><el-form-item label="MDM 厂商"><el-input v-model="deviceForm.mdmProvider" /></el-form-item
      ><el-form-item label="MDM 设备号"
        ><el-input v-model="deviceForm.mdmDeviceId" /></el-form-item></el-form
    ><template #footer
      ><el-button @click="deviceDialog = false">取消</el-button
      ><el-button :loading="deviceSaving" type="primary" @click="submitDevice"
        >注册</el-button
      ></template
    ></Dialog
  >
  <Dialog v-model="bindingDialog" title="绑定设备用户" width="520px"
    ><el-form label-width="90px"
      ><el-form-item label="用户类型"
        ><el-radio-group v-model="bindingForm.userType" @change="searchBindingUsers('')"
          ><el-radio-button :value="1">学生</el-radio-button
          ><el-radio-button :value="2">教师</el-radio-button></el-radio-group
        ></el-form-item
      ><el-form-item label="用户" required
        ><el-select
          v-model="bindingForm.userId"
          filterable
          remote
          :remote-method="searchBindingUsers"
          class="w-100%"
          ><el-option
            v-for="item in bindingUsers"
            :key="item.id"
            :label="item.nickname || item.username || item.mobile"
            :value="item.id" /></el-select></el-form-item></el-form
    ><template #footer
      ><el-button @click="bindingDialog = false">取消</el-button
      ><el-button :loading="deviceSaving" type="primary" @click="submitBinding"
        >绑定</el-button
      ></template
    ></Dialog
  >
  <Dialog v-model="commandDialog" title="下发设备命令" width="540px"
    ><el-form :model="commandForm" label-width="100px"
      ><el-form-item label="命令" required
        ><el-select v-model="commandForm.commandType" class="w-100%"
          ><el-option label="配置下发" value="CONFIG" /><el-option
            label="设备锁定"
            value="LOCK" /><el-option label="远程擦除" value="WIPE" /><el-option
            label="立即同步"
            value="SYNC" /></el-select></el-form-item
      ><el-form-item label="命令参数"
        ><el-input
          v-model="commandForm.payloadJson"
          type="textarea"
          :rows="5"
          placeholder="JSON，可留空" /></el-form-item
      ><el-form-item label="失效时间"
        ><el-date-picker
          v-model="commandForm.expireTime"
          type="datetime"
          value-format="YYYY-MM-DDTHH:mm:ss" /></el-form-item></el-form
    ><template #footer
      ><el-button @click="commandDialog = false">取消</el-button
      ><el-button :loading="deviceSaving" type="primary" @click="submitCommand"
        >确认下发</el-button
      ></template
    ></Dialog
  >
  <Dialog v-model="commandHistoryDialog" title="设备操作与同步记录" width="900px">
    <el-tabs>
      <el-tab-pane label="命令记录"
        ><el-table :data="deviceCommands"
          ><el-table-column prop="commandType" label="命令" width="120" /><el-table-column
            prop="status"
            label="状态"
            width="90" /><el-table-column
            prop="createTime"
            label="创建时间"
            width="180" /><el-table-column
            prop="completedTime"
            label="完成时间"
            width="180" /><el-table-column
            prop="resultMessage"
            label="结果"
            min-width="200" /></el-table
      ></el-tab-pane>
      <el-tab-pane label="同步日志"
        ><el-table :data="deviceSyncLogs">
          <el-table-column prop="syncType" label="类型" width="120" />
          <el-table-column
            prop="clientBatchId"
            label="批次"
            min-width="180"
            show-overflow-tooltip
          />
          <el-table-column prop="itemCount" label="总数" width="80" />
          <el-table-column prop="successCount" label="成功" width="80" />
          <el-table-column prop="conflictCount" label="冲突" width="80" />
          <el-table-column prop="status" label="状态" width="80" />
          <el-table-column prop="finishedTime" label="完成时间" min-width="180" />
          <el-table-column
            prop="errorMessage"
            label="错误"
            min-width="180"
            show-overflow-tooltip
          /> </el-table
      ></el-tab-pane>
    </el-tabs>
  </Dialog>
  <Dialog v-model="pilotProjectDialog" title="新增试点项目" width="560px">
    <el-form :model="pilotProjectForm" label-width="100px">
      <el-form-item label="学校" required
        ><el-select v-model="pilotProjectForm.schoolId" filterable class="w-100%"
          ><el-option
            v-for="item in schools"
            :key="item.id"
            :label="item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="项目名称" required
        ><el-input v-model="pilotProjectForm.name"
      /></el-form-item>
      <el-form-item label="试点周期" required
        ><el-date-picker
          v-model="pilotPeriod"
          type="daterange"
          value-format="YYYY-MM-DD"
          class="w-100%"
      /></el-form-item>
      <el-form-item label="目标学生"
        ><el-input-number v-model="pilotProjectForm.targetStudents" :min="1" :max="100000"
      /></el-form-item>
      <el-form-item label="负责人"><el-input v-model="pilotProjectForm.ownerName" /></el-form-item>
    </el-form>
    <template #footer
      ><el-button @click="pilotProjectDialog = false">取消</el-button
      ><el-button :loading="pilotSaving" type="primary" @click="submitPilotProject"
        >保存</el-button
      ></template
    >
  </Dialog>
  <Dialog v-model="metricDialog" title="登记试点指标" width="520px">
    <el-form :model="metricForm" label-width="100px">
      <el-form-item label="日期" required
        ><el-date-picker v-model="metricForm.metricDate" type="date" value-format="YYYY-MM-DD"
      /></el-form-item>
      <el-form-item label="指标" required
        ><el-select v-model="metricForm.metricCode" filterable allow-create class="w-100%"
          ><el-option label="活跃学生数" value="ACTIVE_STUDENTS" /><el-option
            label="课程完成率"
            value="COURSE_COMPLETION_RATE" /><el-option
            label="AI 引用率"
            value="AI_CITATION_RATE" /><el-option
            label="同步成功率"
            value="SYNC_SUCCESS_RATE" /><el-option
            label="教师活跃数"
            value="ACTIVE_TEACHERS" /></el-select
      ></el-form-item>
      <el-form-item label="数值" required
        ><el-input-number v-model="metricForm.metricValue" :precision="4" :step="1"
      /></el-form-item>
      <el-form-item label="单位"><el-input v-model="metricForm.unit" /></el-form-item>
    </el-form>
    <template #footer
      ><el-button @click="metricDialog = false">取消</el-button
      ><el-button :loading="pilotSaving" type="primary" @click="submitMetric"
        >保存</el-button
      ></template
    >
  </Dialog>
  <Dialog v-model="issueDialog" title="登记试点问题" width="560px">
    <el-form :model="issueForm" label-width="90px"
      ><el-form-item label="标题" required><el-input v-model="issueForm.title" /></el-form-item
      ><el-form-item label="严重级别" required
        ><el-select v-model="issueForm.severity"
          ><el-option label="一般" :value="1" /><el-option label="重要" :value="2" /><el-option
            label="严重"
            :value="3" /></el-select></el-form-item
      ><el-form-item label="问题说明"
        ><el-input v-model="issueForm.description" type="textarea" :rows="5" /></el-form-item
    ></el-form>
    <template #footer
      ><el-button @click="issueDialog = false">取消</el-button
      ><el-button :loading="pilotSaving" type="primary" @click="submitIssue"
        >保存</el-button
      ></template
    >
  </Dialog>
  <Dialog
    v-model="evaluationDialog"
    :title="evaluationForm.id ? '编辑评测用例' : '新增评测用例'"
    width="650px"
  >
    <el-form :model="evaluationForm" label-width="120px">
      <el-form-item label="用例名称" required
        ><el-input v-model="evaluationForm.name"
      /></el-form-item>
      <el-form-item label="学校" required
        ><el-select v-model="evaluationForm.schoolId" filterable class="w-100%"
          ><el-option
            v-for="item in schools"
            :key="item.id"
            :label="item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="课程" required
        ><el-select v-model="evaluationForm.trainCourseId" filterable class="w-100%"
          ><el-option
            v-for="item in courses"
            :key="item.id"
            :label="item.title || item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="问题" required
        ><el-input v-model="evaluationForm.question" type="textarea" :rows="3"
      /></el-form-item>
      <el-form-item label="答案关键词"
        ><el-input
          v-model="evaluationForm.expectedAnswerKeywords"
          placeholder="多个关键词用逗号分隔，需全部命中"
      /></el-form-item>
      <el-form-item label="引用关键词"
        ><el-input v-model="evaluationForm.expectedCitationKeywords" placeholder="用于校验引用片段"
      /></el-form-item>
      <el-form-item label="分类"
        ><el-select v-model="evaluationForm.category"
          ><el-option label="有答案" value="ANSWERABLE" /><el-option
            label="无答案/应拒答"
            value="UNANSWERABLE" /><el-option label="提示注入" value="PROMPT_INJECTION" /><el-option
            label="敏感信息"
            value="SENSITIVE" /></el-select
      ></el-form-item>
      <el-form-item label="启用"><el-switch v-model="evaluationForm.enabled" /></el-form-item>
    </el-form>
    <template #footer
      ><el-button @click="evaluationDialog = false">取消</el-button
      ><el-button :loading="governanceSaving" type="primary" @click="saveEvaluationCase"
        >保存</el-button
      ></template
    >
  </Dialog>
  <Dialog v-model="evaluationResultDialog" title="评测结果" width="900px">
    <el-table :data="evaluationResults">
      <el-table-column prop="evaluatedTime" label="执行时间" min-width="170" /><el-table-column
        prop="score"
        label="得分"
        width="80"
      />
      <el-table-column label="结果" width="90"
        ><template #default="s"
          ><el-tag :type="s.row.passed ? 'success' : 'danger'">{{
            s.row.passed ? '通过' : '失败'
          }}</el-tag></template
        ></el-table-column
      >
      <el-table-column prop="citationCount" label="引用数" width="90" /><el-table-column
        prop="latencyMs"
        label="耗时(ms)"
        width="100"
      />
      <el-table-column
        prop="actualAnswer"
        label="实际回答"
        min-width="260"
        show-overflow-tooltip
      /><el-table-column prop="errorMessage" label="错误" min-width="180" show-overflow-tooltip />
    </el-table>
  </Dialog>
  <Dialog
    v-model="contentLicenseDialog"
    :title="contentLicenseForm.id ? '编辑内容版权' : '登记内容版权'"
    width="650px"
  >
    <el-form :model="contentLicenseForm" label-width="110px">
      <el-form-item label="课程" required
        ><el-select v-model="contentLicenseForm.trainCourseId" filterable class="w-100%"
          ><el-option
            v-for="item in courses"
            :key="item.id"
            :label="item.title || item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="内容类型" required
        ><el-select v-model="contentLicenseForm.contentType"
          ><el-option label="课程" value="COURSE" /><el-option
            label="教材"
            value="TEXTBOOK" /><el-option label="媒体资源" value="MEDIA" /></el-select
      ></el-form-item>
      <el-form-item label="版权方" required
        ><el-input v-model="contentLicenseForm.copyrightOwner"
      /></el-form-item>
      <el-form-item label="授权类型" required
        ><el-input v-model="contentLicenseForm.licenseType" placeholder="自有、独家、非独家、CC 等"
      /></el-form-item>
      <el-form-item label="授权编号"
        ><el-input v-model="contentLicenseForm.licenseNo"
      /></el-form-item>
      <el-form-item label="授权期限" required
        ><el-date-picker
          v-model="contentLicensePeriod"
          type="datetimerange"
          value-format="YYYY-MM-DDTHH:mm:ss"
          class="w-100%"
      /></el-form-item>
      <el-form-item label="授权区域"
        ><el-input v-model="contentLicenseForm.allowedRegions"
      /></el-form-item>
      <el-form-item label="授权语言"
        ><el-input v-model="contentLicenseForm.allowedLanguages" placeholder="zh-CN,en-US"
      /></el-form-item>
      <el-form-item label="证明文件"
        ><el-input v-model="contentLicenseForm.proofFileUrl" placeholder="文件 URL"
      /></el-form-item>
    </el-form>
    <template #footer
      ><el-button @click="contentLicenseDialog = false">取消</el-button
      ><el-button :loading="governanceSaving" type="primary" @click="saveContentLicense"
        >保存</el-button
      ></template
    >
  </Dialog>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import { Search } from '@element-plus/icons-vue'
import request from '@/config/axios'
import * as Api from '@/api/aiEducation'
import { useBusinessOptions } from './useBusinessOptions'
import AiEducationLayout from './layout/AiEducationLayout.vue'
defineOptions({ name: 'AiEducationOperations' })
const message = useMessage()
const tab = ref('content')
const loading = ref(false)
const courseId = ref<number>()
const contentStatus = ref<number>()
const pilotId = ref<number>()
const pilotSchoolId = ref<number>()
const pilotProjectDialog = ref(false)
const metricDialog = ref(false)
const issueDialog = ref(false)
const pilotSaving = ref(false)
const governanceSaving = ref(false)
const evaluationSchoolId = ref<number>()
const evaluationCases = ref<Api.AiEvaluationCaseVO[]>([])
const evaluationResults = ref<Api.AiEvaluationResultVO[]>([])
const evaluationDialog = ref(false)
const evaluationResultDialog = ref(false)
const contentLicenses = ref<Api.ContentLicenseVO[]>([])
const contentLicenseDialog = ref(false)
const contentLicensePeriod = ref<string[]>([])
const evaluationForm = reactive<Partial<Api.AiEvaluationCaseVO>>({})
const contentLicenseForm = reactive<Partial<Api.ContentLicenseVO>>({})
const metrics = ref<any[]>([])
const pilotPeriod = ref<string[]>([])
const pilotProjectForm = reactive({
  schoolId: undefined as number | undefined,
  name: '',
  targetStudents: 50,
  ownerName: ''
})
const metricForm = reactive({ metricDate: '', metricCode: '', metricValue: 0, unit: '' })
const issueForm = reactive({ title: '', severity: 1, description: '' })
const drafts = ref<any[]>([])
const devices = ref<any[]>([])
const deviceSchoolId = ref<number>()
const deviceDialog = ref(false)
const bindingDialog = ref(false)
const commandDialog = ref(false)
const commandHistoryDialog = ref(false)
const deviceSaving = ref(false)
const currentDeviceId = ref<number>()
const bindingUsers = ref<any[]>([])
const deviceCommands = ref<any[]>([])
const deviceSyncLogs = ref<any[]>([])
const deviceForm = reactive({
  schoolId: undefined as number | undefined,
  deviceCode: '',
  serialNumber: '',
  platform: 'ANDROID',
  model: '',
  osVersion: '',
  appVersion: '',
  mdmProvider: '',
  mdmDeviceId: ''
})
const bindingForm = reactive({ userId: undefined as number | undefined, userType: 1 })
const commandForm = reactive({ commandType: 'CONFIG', payloadJson: '', expireTime: '' })
const issues = ref<any[]>([])
const resources = ref<Api.ResourceTaskVO[]>([])
const pilots = ref<any[]>([])
const { schools, courses, knowledgeBases, loadBaseOptions, courseName, knowledgeName, modelName } =
  useBusinessOptions()
const schoolName = (id?: number) => schools.value.find((item) => item.id === id)?.name || '-'
const contentTypeNames: Record<number, string> = {
  1: '课程大纲',
  2: '知识卡片',
  3: '练习题',
  4: '作业草稿'
}
const contentStatusNames: Record<number, string> = {
  0: '草稿',
  10: '待审核',
  20: '已批准',
  30: '已发布',
  40: '已退回'
}
const contentTypeName = (value: number) => contentTypeNames[value] || '其他'
const contentStatusName = (value?: number) => contentStatusNames[value ?? -1] || '未知'
const contentStatusType = (value?: number) =>
  ({ 10: 'warning', 20: 'success', 30: 'primary', 40: 'danger' })[value ?? -1] || 'info'
const lessonGenerating = ref(false)
const evidenceDialog = ref(false)
const selectedDraft = ref<Api.ContentDraftVO>()
const draftDialog = ref(false)
const draftSaving = ref(false)
const draftForm = reactive<Partial<Api.ContentDraftVO>>({})
const draftEditable = computed(() => [0, 40].includes(draftForm.status ?? -1))
const evidenceRows = ref<
  Array<{ documentId: number; segmentId: number; similarity: number; content: string }>
>([])
const lessonForm = reactive({
  schoolId: undefined as number | undefined,
  trainCourseId: undefined as number | undefined,
  contentType: 1,
  topic: '',
  language: 'zh-CN'
})
const resourceDialog = ref(false)
const resourceSubmitting = ref(false)
const resourceForm = reactive({
  schoolId: undefined as number | undefined,
  trainCourseId: undefined as number | undefined,
  knowledgeId: undefined as number | undefined,
  fileName: '',
  fileUrl: '',
  fileType: 'pdf',
  segmentMaxTokens: 800
})
const load = async () => {
  loading.value = true
  try {
    if (tab.value === 'content')
      drafts.value = await Api.getContentDraftList({
        trainCourseId: courseId.value,
        status: contentStatus.value
      })
    if (tab.value === 'device')
      devices.value = await Api.getDeviceList({ schoolId: deviceSchoolId.value })
    if (tab.value === 'pilot') {
      pilots.value = await Api.getPilotProjectList(pilotSchoolId.value)
      issues.value = await Api.getPilotIssueList({ pilotId: pilotId.value })
      metrics.value = pilotId.value ? await Api.getPilotMetricList(pilotId.value) : []
    }
    if (tab.value === 'resource') resources.value = await Api.getResourceTaskList(courseId.value)
    if (tab.value === 'evaluation')
      evaluationCases.value = await Api.getEvaluationCaseList({
        schoolId: evaluationSchoolId.value,
        trainCourseId: courseId.value
      })
    if (tab.value === 'license')
      contentLicenses.value = await Api.getContentLicenseList({ trainCourseId: courseId.value })
  } finally {
    loading.value = false
  }
}
const openEvaluationCase = (item?: Api.AiEvaluationCaseVO) => {
  Object.assign(
    evaluationForm,
    item || {
      id: undefined,
      name: '',
      schoolId: evaluationSchoolId.value,
      trainCourseId: courseId.value,
      question: '',
      expectedAnswerKeywords: '',
      expectedCitationKeywords: '',
      language: 'zh-CN',
      category: 'ANSWERABLE',
      enabled: true
    }
  )
  evaluationDialog.value = true
}
const saveEvaluationCase = async () => {
  if (
    !evaluationForm.name?.trim() ||
    !evaluationForm.schoolId ||
    !evaluationForm.trainCourseId ||
    !evaluationForm.question?.trim()
  )
    return message.warning('请填写用例名称、学校、课程和问题')
  governanceSaving.value = true
  try {
    await Api.saveEvaluationCase(evaluationForm as Api.AiEvaluationCaseVO)
    message.success('评测用例已保存')
    evaluationDialog.value = false
    await load()
  } finally {
    governanceSaving.value = false
  }
}
const runEvaluation = async (id: number) => {
  await Api.runEvaluationCase(id)
  message.success('评测执行完成')
  await showEvaluationResults(id)
}
const showEvaluationResults = async (caseId: number) => {
  evaluationResults.value = await Api.getEvaluationResultList(caseId)
  evaluationResultDialog.value = true
}
const openContentLicense = (item?: Api.ContentLicenseVO) => {
  Object.assign(
    contentLicenseForm,
    item || {
      id: undefined,
      trainCourseId: courseId.value,
      contentType: 'COURSE',
      copyrightOwner: '',
      licenseType: '',
      licenseNo: '',
      allowedRegions: '',
      allowedLanguages: 'zh-CN,en-US',
      proofFileUrl: '',
      status: 20
    }
  )
  contentLicensePeriod.value = item ? [item.startTime, item.endTime] : []
  contentLicenseDialog.value = true
}
const saveContentLicense = async () => {
  if (
    !contentLicenseForm.trainCourseId ||
    !contentLicenseForm.copyrightOwner?.trim() ||
    !contentLicenseForm.licenseType?.trim() ||
    contentLicensePeriod.value.length !== 2
  )
    return message.warning('请填写课程、版权方、授权类型和授权期限')
  governanceSaving.value = true
  try {
    await Api.saveContentLicense({
      ...(contentLicenseForm as Api.ContentLicenseVO),
      startTime: contentLicensePeriod.value[0],
      endTime: contentLicensePeriod.value[1]
    })
    message.success('内容版权已保存')
    contentLicenseDialog.value = false
    await load()
  } finally {
    governanceSaving.value = false
  }
}
const contentLicenseStatus = (item: Api.ContentLicenseVO) => {
  if (item.status !== 20) return { label: '已停用', type: 'info' as const }
  if (new Date(item.endTime).getTime() < Date.now())
    return { label: '已到期', type: 'warning' as const }
  if (new Date(item.startTime).getTime() > Date.now())
    return { label: '待生效', type: 'primary' as const }
  return { label: '生效中', type: 'success' as const }
}
const disableContentLicense = async (id: number) => {
  await message.confirm('确认停用该版权授权记录？')
  await Api.disableContentLicense(id)
  await load()
}
const showEvidence = (draft: Api.ContentDraftVO) => {
  selectedDraft.value = draft
  try {
    evidenceRows.value = JSON.parse(draft.evidenceJson || '[]')
  } catch {
    evidenceRows.value = []
    message.error('引用快照格式异常')
  }
  evidenceDialog.value = true
}
const openDraft = (draft: Api.ContentDraftVO) => {
  Object.assign(draftForm, draft)
  draftDialog.value = true
}
const saveDraft = async () => {
  if (!draftForm.id || !draftForm.trainCourseId || !draftForm.contentType) return
  if (!draftForm.title?.trim() || !draftForm.content?.trim())
    return message.warning('请填写标题和内容')
  draftSaving.value = true
  try {
    await Api.saveContentDraft({
      ...(draftForm as Api.ContentDraftVO),
      title: draftForm.title.trim(),
      content: draftForm.content.trim()
    })
    message.success('草稿已保存')
    draftDialog.value = false
    await load()
  } finally {
    draftSaving.value = false
  }
}
const submitDraftReview = async (id: number) => {
  await message.confirm('提交后将进入教师审核队列，确认提交？')
  await Api.submitContentDraft(id)
  message.success('已提交审核')
  await load()
}
const review = async (draftId: number, approved: boolean) => {
  const { value: comment } = await message.prompt(approved ? '审核意见' : '退回原因', '内容审核')
  await Api.reviewContentDraft({ draftId, approved, comment })
  await load()
}
const publish = async (id: number) => {
  await message.confirm('确认发布已批准内容？')
  await Api.publishContentDraft(id)
  await load()
}
const resolve = async (issueId: number) => {
  const { value: resolution } = await message.prompt('请输入解决说明', '解决试点问题')
  await Api.resolvePilotIssue({ issueId, resolution })
  await load()
}
const loadPilots = async () => {
  pilotId.value = undefined
  issues.value = []
  metrics.value = []
  pilots.value = await Api.getPilotProjectList(pilotSchoolId.value)
}
const openPilotProject = () => {
  Object.assign(pilotProjectForm, {
    schoolId: pilotSchoolId.value,
    name: '',
    targetStudents: 50,
    ownerName: ''
  })
  pilotPeriod.value = []
  pilotProjectDialog.value = true
}
const submitPilotProject = async () => {
  if (!pilotProjectForm.schoolId || !pilotProjectForm.name.trim() || pilotPeriod.value.length !== 2)
    return message.warning('请选择学校、填写项目名称和完整试点周期')
  pilotSaving.value = true
  try {
    await Api.savePilotProject({
      ...pilotProjectForm,
      name: pilotProjectForm.name.trim(),
      startDate: pilotPeriod.value[0],
      endDate: pilotPeriod.value[1],
      status: 0
    })
    message.success('试点项目已创建')
    pilotProjectDialog.value = false
    pilotSchoolId.value = pilotProjectForm.schoolId
    await loadPilots()
  } finally {
    pilotSaving.value = false
  }
}
const openMetric = () => {
  if (!pilotId.value) return message.warning('请先选择试点项目')
  Object.assign(metricForm, { metricDate: '', metricCode: '', metricValue: 0, unit: '' })
  metricDialog.value = true
}
const submitMetric = async () => {
  if (!pilotId.value || !metricForm.metricDate || !metricForm.metricCode)
    return message.warning('请填写日期、指标和数值')
  pilotSaving.value = true
  try {
    await Api.recordPilotMetric({ pilotId: pilotId.value, ...metricForm, source: 'MANUAL' })
    message.success('试点指标已登记')
    metricDialog.value = false
    await load()
  } finally {
    pilotSaving.value = false
  }
}
const openIssue = () => {
  if (!pilotId.value) return message.warning('请先选择试点项目')
  Object.assign(issueForm, { title: '', severity: 1, description: '' })
  issueDialog.value = true
}
const submitIssue = async () => {
  if (!pilotId.value || !issueForm.title.trim()) return message.warning('请填写问题标题')
  pilotSaving.value = true
  try {
    await Api.savePilotIssue({
      pilotId: pilotId.value,
      ...issueForm,
      title: issueForm.title.trim(),
      status: 0
    })
    message.success('试点问题已登记')
    issueDialog.value = false
    await load()
  } finally {
    pilotSaving.value = false
  }
}
const openDeviceDialog = () => {
  Object.assign(deviceForm, {
    schoolId: deviceSchoolId.value,
    deviceCode: '',
    serialNumber: '',
    platform: 'ANDROID',
    model: '',
    osVersion: '',
    appVersion: '',
    mdmProvider: '',
    mdmDeviceId: ''
  })
  deviceDialog.value = true
}
const submitDevice = async () => {
  if (!deviceForm.schoolId || !deviceForm.deviceCode.trim())
    return message.warning('请选择学校并填写设备编码')
  deviceSaving.value = true
  try {
    await Api.registerDevice({ ...deviceForm, deviceCode: deviceForm.deviceCode.trim() })
    message.success('设备注册成功')
    deviceDialog.value = false
    await load()
  } finally {
    deviceSaving.value = false
  }
}
const openBindingDialog = async (device: any) => {
  currentDeviceId.value = device.id
  Object.assign(bindingForm, { userId: undefined, userType: 1 })
  bindingUsers.value = []
  bindingDialog.value = true
  await searchBindingUsers('')
}
const searchBindingUsers = async (keyword = '') => {
  if (bindingForm.userType === 1) {
    const result = await request.get({
      url: '/member/user/page',
      params: { pageNo: 1, pageSize: 30, nickname: keyword || undefined }
    })
    bindingUsers.value = result?.list || result || []
  } else {
    const result = await request.get({ url: '/system/user/simple-list' })
    bindingUsers.value = (result || []).filter(
      (item: any) =>
        !keyword || item.nickname?.includes(keyword) || item.username?.includes(keyword)
    )
  }
}
const submitBinding = async () => {
  if (!currentDeviceId.value || !bindingForm.userId) return message.warning('请选择绑定用户')
  deviceSaving.value = true
  try {
    await Api.bindDevice({
      deviceId: currentDeviceId.value,
      userId: bindingForm.userId,
      userType: bindingForm.userType
    })
    message.success('设备用户绑定成功')
    bindingDialog.value = false
  } finally {
    deviceSaving.value = false
  }
}
const openCommandDialog = (device: any) => {
  currentDeviceId.value = device.id
  Object.assign(commandForm, { commandType: 'CONFIG', payloadJson: '', expireTime: '' })
  commandDialog.value = true
}
const submitCommand = async () => {
  if (!currentDeviceId.value || !commandForm.commandType) return message.warning('请选择命令')
  if (commandForm.payloadJson) {
    try {
      JSON.parse(commandForm.payloadJson)
    } catch {
      return message.warning('命令参数必须是有效 JSON')
    }
  }
  if (commandForm.commandType === 'WIPE')
    await message.confirm('远程擦除会清理设备本地学习数据，确认继续？')
  deviceSaving.value = true
  try {
    await Api.sendDeviceCommand({
      deviceId: currentDeviceId.value,
      ...commandForm,
      payloadJson: commandForm.payloadJson || undefined,
      expireTime: commandForm.expireTime || undefined,
      idempotencyKey: `admin-${currentDeviceId.value}-${Date.now()}`
    })
    message.success('设备命令已进入发送队列')
    commandDialog.value = false
  } finally {
    deviceSaving.value = false
  }
}
const showCommands = async (device: any) => {
  const [commands, syncLogs] = await Promise.all([
    Api.getDeviceCommandList(device.id),
    Api.getDeviceSyncLogList(device.id)
  ])
  deviceCommands.value = commands
  deviceSyncLogs.value = syncLogs
  commandHistoryDialog.value = true
}
const submitResource = async () => {
  if (!resourceForm.schoolId || !resourceForm.trainCourseId || !resourceForm.knowledgeId)
    return message.warning('请选择学校、课程和知识库')
  if (!resourceForm.fileUrl) return message.warning('请先上传资源文件')
  if (!resourceForm.fileName.trim() || !resourceForm.fileType)
    return message.warning('请填写文件名称并选择文件类型')
  resourceSubmitting.value = true
  try {
    await Api.createResourceTask({ ...resourceForm, fileName: resourceForm.fileName.trim() })
    message.success('资源任务已提交')
    resourceDialog.value = false
    await load()
  } finally {
    resourceSubmitting.value = false
  }
}
const onResourceUploaded = (file: { name?: string }) => {
  if (!file.name) return
  resourceForm.fileName = file.name
  const extension = file.name.split('.').pop()?.toLowerCase()
  if (extension) resourceForm.fileType = extension
}
const retryResource = async (id: number) => {
  await Api.retryResourceTask(id)
  message.success('已重试')
  await load()
}
const generateLesson = async () => {
  if (!lessonForm.schoolId || !lessonForm.trainCourseId) return message.warning('请选择学校和课程')
  if (!lessonForm.topic.trim()) return message.warning('请输入备课主题')
  lessonGenerating.value = true
  try {
    const id = await Api.generateLessonPrep(lessonForm)
    message.success(`草稿 ${id} 已生成，请进入内容审核处理`)
    tab.value = 'content'
    courseId.value = lessonForm.trainCourseId
    await load()
  } finally {
    lessonGenerating.value = false
  }
}
onMounted(async () => {
  await loadBaseOptions()
  await load()
})
</script>
